import { AxiosError } from "axios";
import { errorToastHook } from "../components/toasts/error";
import { useSessionStore } from "../store/session.store";

export function useErrorHandler() {
  const setSessionExpiryModalOpened = useSessionStore(
    (state) => state.setSessionExpiryModalOpened
  );

  const handleError = (error: any) => {

    if (error instanceof AxiosError && error?.response?.status === 401) {
      setSessionExpiryModalOpened(true);
    } else if (error instanceof AxiosError) {
      errorToastHook({
        msg: error?.response?.statusText || "Oops!! Something went wrong",
      });
    } else if (error instanceof Error) {
      errorToastHook({
        msg: error?.message || "Oops!! Something went wrong",
      });
    } else {
      errorToastHook({
        msg: "Oops!! Something went wrong",
      });
    }
  };

  return { handleError };
}
